<template>
  <el-select placeholder="請選擇項目"
    v-model="itemLocal"
    :disabled="loading"
    @change="beforeSelectItem"
  >
    <el-option
      v-for="(item, index) in items"
      :key="index"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { items } from '@/helpers/resourcesItems'

export default {
  props: {
    level: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      items: null,
      itemLocal: ''
    }
  },
  computed: {
    ...mapGetters({
      params: 'download/params',
      loading: 'loading/loading'
    }),
  },
  methods: {
    ...mapActions({
      selectItem: 'download/selectItem'
    }),
    ...mapMutations({
      setItem: 'download/setItem'
    }),
    beforeSelectItem (item) {
      this.selectItem({ item: item })
    },
    setOptions () {
      let i = (this.level === 'lt') ? 0 : 1
      this.items = items[i].children
    },
    init () {
      this.setItem({ item: '1' })
      this.itemLocal = '1'
      this.setOptions()
    }
  },
  mounted () {
    this.init()
  }
}
</script>
